module.exports = __webpack_public_path__ + "img/grid.44e9336.svg";